<template>
  <div class="teach-con">
    <div class="title">五步学好拍照，找布更快</div>
    <div class="step01">
      <div class="num"></div>
      <div class="tips">请铺平、拍全花型</div>
      <div class="img">
        <div class="left">
          <div class="res">正确</div>
        </div>
        <div class="right">
          <div class="err">错误</div>
        </div>
      </div>
      <div class="tips-p">
        将面料铺开<span>保持平整</span>，展示<span>完整花型</span>，让面料铺满相机取景框。
      </div>
    </div>

    <div class="step02">
      <div class="num"></div>
      <div class="tips">拍摄距离15公分左右</div>
      <div class="img">
        <div class="left">
          <div class="res">正确</div>
        </div>
        <div class="right">
          <div class="err">错误</div>
        </div>
      </div>
      <div class="tips-p">
        保持拍摄距离为15公分左右。拍摄时<span>中指和拇指垂直，中指顶住布料，拇指顶住手机，</span>按此距离拍摄即可。
      </div>
    </div>

    <div class="step03">
      <div class="num"></div>
      <div class="tips">离布料约15公分不倾斜</div>
      <div class="img">
        <div class="left">
          <div class="res">正确</div>
        </div>
        <div class="right">
          <div class="err">错误</div>
        </div>
      </div>
      <div class="tips-p">
        拍摄时需保持拍摄设备的相对水平如特殊情况必须带有角度，则手机（拍摄设备）也需以<span>平行的相应角度拍摄。</span>
      </div>
    </div>

    <div class="step04">
      <div class="num"></div>
      <div class="tips">避免阴影</div>
      <div class="img">
        <div class="left">
          <div class="res">正确</div>
        </div>
        <div class="right">
          <div class="err">错误</div>
        </div>
      </div>
      <div class="tips-p">
        光线适当，拍摄时<span>避免阴影。</span>
      </div>
    </div>

    <div class="step05">
      <div class="num"></div>
      <div class="tips">避免模糊</div>
      <div class="img">
        <div class="left">
          <div class="res">正确</div>
        </div>
        <div class="right">
          <div class="err">错误</div>
        </div>
      </div>
      <div class="tips-p">
        拍摄图片时对<span>焦后</span>进行拍摄。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaibuTeach',
  data() {
    return {};
  },

  created() {

  },

  mounted() {

  },

  computed: {},

  components: {},

  methods: {},
};
</script>

<style scoped lang="scss">
  .title{
    padding: 20px 0;
    text-align: center;
    color: #ea4100;
    font-size: 22px;
  }
  .step01,
  .step02,
  .step03,
  .step04,
  .step05{
    margin-bottom: 20px;
    text-align: center;
    .num{
      width: 65px;
      height: 65px;
      margin: 0 auto;
      background-image: url("../../assets/baibu/baibu_teach_numbers.png");
      background-size: 325px 65px;
    }
    .tips{
      margin: 15px 0;
      font-size: 26px;
      font-weight: 700;
      color: #ea4100;
    }
    .img{
      display: flex;
      justify-content: space-between;
      width: 288px;
      margin: 0 auto;
      color: #FFFFFF;
      .left{
        width: 137px;
        font-size: 18px;
        text-align: center;
        border: 1px solid #ea4100;
        background-color: #ea4100;
        border-radius: 5px;
        .res{
          padding: 13px;
        }
        &:after{
          content: '';
          display: block;
          width: 100%;
          height: 165px;
          background-image: url("../../assets/baibu/one_right.png");
          background-size: cover;
        }
      }
      .right{
        width: 137px;
        font-size: 18px;
        border: 1px solid #999999;
        background-color: #777777;
        border-radius: 5px;
        .err{
          padding: 13px;
        }
        &:after{
          content: '';
          display: block;
          width: 100%;
          height: 165px;
          background-image: url("../../assets/baibu/one_wrong.png");
          background-size: cover;
        }
      }
    }
    .tips-p{
      width: 288px;
      margin: 0 auto;
      padding-top: 8px;
      font-size: 16px;
      line-height: 1.4;
      color: #999999;
      span{
        color: #ea4100;
      }
    }
  }
  .step02{
    .num{
      background-position-x: -65px;
    }
    .img{
      .left{
        &:after{
          background-image: url("../../assets/baibu/two_right.png");
        }
      }
      .right{
        &:after{
          background-image: url("../../assets/baibu/two_wrong.png");
        }
      }
    }
  }
  .step03{
    .num{
      background-position-x: -130px;
    }
    .img{
      .left{
        &:after{
          background-image: url("../../assets/baibu/three_right.png");
        }
      }
      .right{
        &:after{
          background-image: url("../../assets/baibu/three_wrong.png");
        }
      }
    }
  }
  .step04{
    .num{
      background-position-x: -195px;
    }
    .img{
      .left{
        &:after{
          background-image: url("../../assets/baibu/four_right.png");
        }
      }
      .right{
        &:after{
          background-image: url("../../assets/baibu/four_wrong.png");
        }
      }
    }
  }
  .step05{
    .num{
      background-position-x: -260px;
    }
    .img{
      .left{
        &:after{
          background-image: url("../../assets/baibu/five_right.png");
        }
      }
      .right{
        &:after{
          background-image: url("../../assets/baibu/five_wrong.png");
        }
      }
    }
  }
</style>
